// src/index.js
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

// IMPORTS CRUCIALES DE AMPLIFY
import { Amplify } from 'aws-amplify';
import awsExports from './aws-exports'; 
// 🛑 IMPORTANTE: Importar el proveedor de autenticación
import { Authenticator } from '@aws-amplify/ui-react'; 
import '@aws-amplify/ui-react/styles.css'; 

// Configuración de Amplify (Conexión al Backend)
Amplify.configure(awsExports);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    {/* 🛑 CORRECTO: Envolvemos App con el proveedor de estado de autenticación */}
    <Authenticator.Provider>
        <App />
    </Authenticator.Provider>
  </React.StrictMode>
);